/**
 * Return quadratic length
 *
 * @module  mumath/len
 *
 */

export default function len(a, b) {
	return Math.sqrt(a*a + b*b);
};
